<template>
  <SelectWithSearch
    id="natureza"
    label="Natureza"
    labelBusca="description"
    placeholder="Pesquise uma natureza"
    ref="searchNatureza"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :resizeSearchField="false"
    :change="change"
    :options="nfseNatureOfOperationCollection"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
    <template slot="no-options"> Selecione a natureza </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectNfseNatureOfOperation',
  components: {
    SelectWithSearch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    error: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setNfseNatureOfOperationCollection();
  },
  computed: {
    ...mapState('fiscalComponents', ['nfseNatureOfOperationCollection']),
  },
  methods: {
    ...mapActions('fiscalComponents', ['setNfseNatureOfOperationCollection']),

    change(value) {
      this.$emit('input', value);
    },
    formatOptions(props) {
      return `${props.data.code} - ${props.data.description}`;
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
